/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ATMMarkdownContainer from "src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer";
import { useGetBlogByIdQuery } from "src/services/BlogServices";

const ViewBlog = () => {
  const { id = "" } = useParams();
  const [Blog, setBlogData] = useState<any>({});
  const { data, isLoading, isFetching } = useGetBlogByIdQuery(id);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setBlogData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex justify-between">
        <p className="flex-1 text-5xl font-semibold">{Blog?.title}</p>
        <img
          src={Blog?.bannerImage}
          className="overflow-hidden w-96 aspect-video"
          alt="bannerimage"
        />
      </div>
      <ATMMarkdownContainer markdown={Blog?.description} />
    </div>
  );
};

export default ViewBlog;
